import { Check } from 'lucide-react';

const STEPS = [
  { title: 'Discovery', text: 'We learn your goals, users and constraints, then agree on scope and success metrics.' },
  { title: 'Design & architecture', text: 'We plan the experience and the technical structure before writing production code.' },
  { title: 'Build & test', text: 'We develop in milestones you can review, with testing at every stage.' },
  { title: 'Launch & support', text: 'We deploy, monitor and keep improving after go-live.' }
];

const H2 = 'font-inter font-black text-3xl md:text-4xl tracking-[-0.03em] text-foreground mb-6';
const CARD = 'rounded-2xl border border-border/30 bg-card/30 backdrop-blur-sm p-6';

export default function ServiceDetailBody({ page }) {
  return (
    <>
      <section className="mb-16">
        <h2 className={H2}>What's included</h2>
        <ul className={`${CARD} space-y-3`}>
          {page.included.map((item) => (
            <li key={item} className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0 mt-0.5">
                <Check className="w-3 h-3 text-primary" />
              </div>
              <span className="text-sm text-muted-foreground font-inter">{item}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="mb-16">
        <h2 className={H2}>How we work</h2>
        <ol className="grid sm:grid-cols-2 gap-4">
          {STEPS.map((step, i) => (
            <li key={step.title} className={CARD}>
              <span className="text-xs font-inter font-medium tracking-[0.2em] uppercase text-primary">Step {i + 1}</span>
              <h3 className="font-inter font-bold text-lg text-foreground mt-2 mb-2">{step.title}</h3>
              <p className="text-sm text-muted-foreground font-inter leading-relaxed">{step.text}</p>
            </li>
          ))}
        </ol>
      </section>

      <section className="mb-16">
        <h2 className={H2}>Who it's for</h2>
        <ul className={`${CARD} space-y-3`}>
          {page.whoFor.map((line) => (
            <li key={line} className="text-sm text-muted-foreground font-inter leading-relaxed">{line}</li>
          ))}
        </ul>
      </section>
    </>
  );
}